<span class="userinfo" *ngIf="this.user">User: {{ this.username }}
    <button mat-icon-button (click)="this.logout()" class="logout" matTooltip="Log Out">
        <mat-icon>power_settings_new</mat-icon>
    </button>
</span>